import * as getters from './getters';

import actions from './actions';
import mutations from './mutations';

import { PROFILE_FEED_TAB_KEYS } from '~/utils/profile-feed-tab-keys';

const state = () => ({
  // Profile
  contentStep: 0,
  contentMode: 'followers',
  profile: null,
  profileLoading: false,
  profileError: null,
  showProfileEditModal: false,
  hasSeenWTPModal: false,
  // Profile feed
  feed: null,
  feedLoading: false,
  feedError: null,
  postFeed: null,
  postFeedLoading: false,
  postFeedError: null,
  repliesFeed: null,
  repliesFeedLoading: false,
  repliesFeedError: null,
  nextPostLoading: false,
  nextPostFeedLoading: false,
  nextRepliesFeedLoading: false,
  lastFetchedProfileId: null,
  feedTabs: [
    {
      key: PROFILE_FEED_TAB_KEYS.POSTS,
      titleKey: 'profile_posts',
      index: 0,
    },
    {
      key: PROFILE_FEED_TAB_KEYS.REPLIES,
      titleKey: 'profile_replies',
      index: 1,
    },
  ],
  activeFeedTab: {
    key: PROFILE_FEED_TAB_KEYS.POSTS,
    titleKey: 'profile_posts',
    index: 0,
  },

  // Profile followers
  followers: null,
  followersLoading: false,
  followersPage: 1,
  nextFollowersLoading: false,
  followersError: null,
  showLoadMoreFollowers: false,
  // Profile followed
  followed: null,
  followedLoading: false,
  followedPage: 1,
  nextFollowedLoading: false,
  followedError: null,
  showLoadMoreFollowed: false,
  followedCountPerType: { data: null, loading: false, error: null },

  createProfile: { data: null, loading: null, error: null },
  deleteProfile: { data: null, loading: false, error: null },

  deleteUserPost: { data: null, loading: false, error: null },
});

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
